export const MAX_COMMENT_IMAGES = 3;